export let CentralProgramUserGroup = /*#__PURE__*/function (CentralProgramUserGroup) {
  CentralProgramUserGroup["Admin"] = "Central Prog Admin";
  CentralProgramUserGroup["Planner"] = "Central Prog Planner";
  return CentralProgramUserGroup;
}({});